import { createContext } from 'react'

const JourneyWhiteLabelContext = createContext()

export default JourneyWhiteLabelContext
